import { QuestionTypes } from "@/constants/questionsIds";

type CommonAnswer = { id: string; text: string };
type AnswerWithDescription = CommonAnswer & { description?: string };
type AnswerWithImg = CommonAnswer & { img: string };

export interface AnswerVariantTypeByQuestionType {
    [QuestionTypes.Checkbox]: AnswerWithImg &
        AnswerWithDescription & {
            svg?: IconComponent;
        };
    [QuestionTypes.CheckboxImageLeft]: AnswerWithImg;
    [QuestionTypes.CheckboxInline]: AnswerWithImg & { selectedImg?: string };
    [QuestionTypes.Radio]: AnswerWithDescription & {
        svg?: IconComponent;
    };
    [QuestionTypes.RadioImageLeft]: AnswerWithImg &
        AnswerWithDescription & {
            svg?: IconComponent;
            desktopImg?: string;
        };
    [QuestionTypes.Range]: Omit<AnswerWithImg, "text"> & { value: string };
    [QuestionTypes.RadioCards]: AnswerWithImg;
    [QuestionTypes.YesNo]: CommonAnswer & {
        icon?: IconComponent;
    };
}

export const enum TargetAreasAnswers {
    belly = "abs",
    fullBody = "full_body",
    butt = "glutes",
    chest = "chest",
    legs = "legs",
    shoulders = "shoulders",
    arms = "arms",
    back = "core",
}

export const enum EventAnswers {
    vacation = "vacation",
    wedding = "wedding",
    reunion = "reunion",
    school_reunion = "school_reunion",
    birthday = "birthday",
    family_gathering = "family_gathering",
    none = "none",
}

export const enum ActionPlanAnswers {
    as_quickly_as_possible = "as_quickly_as_possible",
    slow_and_steady = "slow_and_steady",
    somewhere_between_the_two = "somewhere_between_the_two",
}

export const enum PaceAnswers {
    fast = "fast",
    steady = "steady",
    between_two = "between_two",
}

export const enum WeightLossGoal {
    one_to_ten = "1-10",
    eleven_to_twenty = "11-20",
    twenty_plus = "20+",
    maintain_weight = "maintain_weight",
    not_decided = "not_decided",
}

export const enum InterestsAnswers {
    body_sculpting = "body_sculpting",
    strength = "strength",
    agility = "agility",
    heart_health = "heart_health",
    general_fitness = "general_fitness",
    fat_burn = "fat_burn",
    endurance = "endurance",
    energy = "energy",
    consistency = "consistency",
    libido_boost = "libido_boost",
    flexibility = "flexibility",
    mobility = "mobility",
    recovery = "recovery",
}

export const enum HealthProblemsAnswers {
    backPain = "backPain",
    kneePain = "kneePain",
    shoulderPain = "shoulderPain",
    neckPain = "neckPain",
    armPain = "armPain",
    elbowPain = "elbowPain",
    legPain = "legPain",
    footPain = "footPain",
    none = "none",
}

export const enum EquipmentAnswers {
    dumbbells = "dumbbells",
    yogaMat = "yogaMat",
    barbell = "barbell",
    jumpRope = "jumpRope",
    pullups = "pullups",
    powerBand = "powerBand",
    kettlebell = "kettlebell",
    no = "no",
}

export const enum SportPreferAnswers {
    morning = "morning",
    afternoon = "afternoon",
    evening = "evening",
    different = "different",
}

export const enum DesiredWorkoutTimeAnswers {
    thirty = "30",
    fortyFive = "45",
    sixty = "60",
    sixtyPlus = "60+",
}

export const enum DailyWalkAnswers {
    few = "few",
    average = "average",
    lot = "lot",
}

export const enum OtherSportsAnswers {
    no = "no",
    cardio = "cardio",
    flexibility = "flexibility",
    martial_arts = "martial_arts",
    game_sports = "game_sports",
}

export const enum Train3MonthsAnswers {
    hardly_ever = "hardly_ever",
    one_2_per_week = "1_2_per_week",
    three_4_per_week = "3_4_per_week",
    five_6_per_week = "5_6_per_week",
    everyday = "everyday",
}

export const enum PushUpsSquartsAnswers {
    few = "few",
    average = "average",
    lot = "lot",
    no_info = "no_info",
}

export const enum WaterConsumption {
    no_water = "no_water",
    low = "low",
    average = "average",
    above_average = "above_average",
    lot = "lot",
}
